module.exports = __webpack_public_path__ + "img/card1.cee46223.png";